"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftMetadataToJSON = exports.NftMetadataFromJSONTyped = exports.NftMetadataFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function NftMetadataFromJSON(json) {
    return NftMetadataFromJSONTyped(json, false);
}
exports.NftMetadataFromJSON = NftMetadataFromJSON;
function NftMetadataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'tokenId': json['tokenId'],
        'contractAddress': json['contractAddress'],
        'tokenUri': !(0, runtime_1.exists)(json, 'tokenUri') ? undefined : json['tokenUri'],
        'tokenImageUrl': !(0, runtime_1.exists)(json, 'tokenImageUrl') ? undefined : json['tokenImageUrl'],
        'tokenName': !(0, runtime_1.exists)(json, 'tokenName') ? undefined : json['tokenName'],
        'tokenDescription': !(0, runtime_1.exists)(json, 'tokenDescription') ? undefined : json['tokenDescription'],
        'evmChain': !(0, runtime_1.exists)(json, 'evmChain') ? undefined : (0, _1.EVMChainFromJSON)(json['evmChain']),
        'attributes': !(0, runtime_1.exists)(json, 'attributes') ? undefined : (json['attributes'].map(_1.NftMetadataAttributeFromJSON)),
        'isVirtual': !(0, runtime_1.exists)(json, 'isVirtual') ? undefined : json['isVirtual'],
    };
}
exports.NftMetadataFromJSONTyped = NftMetadataFromJSONTyped;
function NftMetadataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'tokenId': value.tokenId,
        'contractAddress': value.contractAddress,
        'tokenUri': value.tokenUri,
        'tokenImageUrl': value.tokenImageUrl,
        'tokenName': value.tokenName,
        'tokenDescription': value.tokenDescription,
        'evmChain': (0, _1.EVMChainToJSON)(value.evmChain),
        'attributes': value.attributes === undefined ? undefined : (value.attributes.map(_1.NftMetadataAttributeToJSON)),
        'isVirtual': value.isVirtual,
    };
}
exports.NftMetadataToJSON = NftMetadataToJSON;
